import { useAuth } from "@myplant-io/hooks";
import { useGetHelpDialog } from "@myplant-io/lab";
import { API_BASE_URL } from "../constants";

export const GetHelpDialog = () => {
  const { data } = useAuth(API_BASE_URL);
  const { render: renderGetHelpDialog } = useGetHelpDialog({
    apiOptions: {
      baseUrl: "/ws/ticket-gateway",
    },
    ticketDefaults: {
      group: "AI Assistant - Level 1 Support",
      feature: "myplant AI:: Assistant",
      reference_link: window.location.href,
      customer: data?.user?.email?.toLocaleLowerCase(),
    },
    attachmentsProps: { enabled: true },
    getTicketLink: (id: number): string => {
      return `https://tickets.myplant.io/#ticket/zoom/${id}`;
    },
  });
  return <>{renderGetHelpDialog()}</>;
};
